var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Rachunki")]),_c('v-card-text',[_c('BillKm',{staticClass:"mr-4"}),_c('BillUser')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }